import request from '@/utils/request'

export function findAgentsModuleProducts(params) {
  return request({
    url: `/agents_module_products`,
    method: 'get',
    params
  })
}

export function importAgentsModuleProducts(data) {
  return request({
    url: `/agents_module_products/import`,
    method: 'post',
    data
  })
}

export function findAgentsModuleProductForm(id) {
  return request({
    url: `/agents_module_products/${id}/form`,
    method: 'get'
  })
}

export function updateAgentsModuleProduct(id, data) {
  return request({
    url: `/agents_module_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateAgentsModuleProductsEffective(ids, effective) {
  return request({
    url: `/agents_module_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
